module.exports = __webpack_public_path__ + "static/media/ICICI.d02e0dc9.png";